import { Component, inject, signal } from '@angular/core';
import { StyleSheetSpriteComponent } from '@features/styles/style-sheet-sprite/style-sheet-sprite.component';
import { StylesService, TSprite } from '@features/styles/styles.service';

@Component({
  selector: 'app-sprite-sheet',
  imports: [StyleSheetSpriteComponent],
  templateUrl: './sprite-sheet.component.html',
  styleUrl: './sprite-sheet.component.css',
})
export class SpriteSheetComponent {
  _styleService = inject(StylesService);
  index = signal(0);

  getSprite(name: string) {
    return this._styleService[name as keyof StylesService]();
  }

  scale(sprite: TSprite | undefined, scale: number) {
    if (!sprite) return undefined;

    return { ...sprite, scale };
  }
}
